<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Логи</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CRow>
                            <CCol cols="12" md="6">
                                <CSelect
                                    class="mb-2"
                                    label="Кто"
                                    horizontal
                                    :value.sync="filter.administrator_id"
                                    :options="filterOptions.administrators"
                                    placeholder="Выберите администратора..."
                                />
                                <CSelect
                                    class="mb-2"
                                    label="С чем"
                                    horizontal
                                    :value.sync="filter.object_type"
                                    :options="filterOptions.objectTypes"
                                    placeholder="Выберите тип объекта..."
                                />
                                <CSelect
                                    class="mb-2"
                                    label="Что"
                                    horizontal
                                    :value.sync="filter.operation_type"
                                    :options="filterOptions.operationTypes"
                                    placeholder="Выберите тип операции..."
                                />
                                <CInput
                                    v-model="filter.object_id"
                                    class="mb-2"
                                    label="ID"
                                    horizontal
                                    placeholder="Введите идентификатор объекта..."
                                />
                                <CButton
                                    color="primary"
                                    class="mb-4 mr-2"
                                    @click="fetchList"
                                >Фильтр</CButton
                                >
                                <CButton
                                    color="secondary"
                                    variant="outline"
                                    class="mb-4"
                                    @click="clearFilter"
                                >Сбросить</CButton
                                >
                            </CCol>
                        </CRow>
                    </CForm>
                    <CDataTable
                        hover
                        sorter
                        :items="list"
                        :fields="fields">
                        <template #when="data">
                            <td>{{ formatDate(data.item.when) }}</td>
                        </template>
                        <template #administrator_id="data">
                            <td>
                                {{ getAdministrator(data.item.administrator_id) }}
                            </td>
                        </template>
                        <template #payload="data">
                            <td>
                                <CButton
                                    @click="showDetailsDialog(data.item.id)"
                                ><CIcon
                                    :content="$options.icons.cilInfo"
                                /></CButton>
                            </td>
                        </template>
                    </CDataTable>

                    <CPagination
                        v-if="total > 1"
                        class="mt-4"
                        :active-page.sync="activePage"
                        :pages="total"
                        align="center"
                    />
                </CCardBody>
                <CCardFooter />
            </CCard>
        </CCol>

        <CModal
            title="Информация"
            color="info"
            :show.sync="showDetails"
            :footer="false"
            size="lg"
        >
            <template>
                <pre>{{ logDetailsCode(logDetails.payload) }}</pre>
                <div slot="footer"></div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    const { ITEMS_PER_PAGE, formatDate } = require('../../../utils/views');
    const { OBJECT_TYPE, OPERATION_TYPE } = require('../../../utils/change-log');
    import { cilInfo } from '@coreui/icons';

    export default {
        name: 'ChangeLogs',

        components: {},

        icons: {
            cilInfo,
        },

        data() {
            return {
                fields: [
                    { key: 'when', label: 'Когда' },
                    { key: 'administrator_id', label: 'Кто' },
                    { key: 'object_type', label: 'С чем' },
                    { key: 'operation_type', label: 'Что' },
                    { key: 'object_id', label: 'ID' },
                    { key: 'payload', label: 'Детали' },
                ],
                list: [],
                logDetails: {},
                showDetails: false,
                itemsPerPage: ITEMS_PER_PAGE,
                total: 0,
                filter: {
                    administrator_id: '',
                    object_type: '',
                    operation_type: '',
                    object_id: '',
                },
                filterOptions: {
                    administrators: [],
                    objectTypes: [],
                    operationTypes: [],
                },
                administrators: []
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'fetchList',
        },

        async created() {
            await Promise.all([this.fetchList(), this.fetchOptions()]);
        },

        methods: {
            showDetailsDialog(logId) {
                for (var i = 0; i < this.list.length; i++) {
                    if (logId === this.list[i].id) {
                        this.logDetails = this.list[i];
                    }
                }
                this.showDetails = true;
            },
            formatDate(date) {
                return formatDate(date);
            },
            logDetailsCode(details) {
                var code = details;
                if (details) {
                    try {
                        const detailsObj = JSON.parse(details);
                        if (detailsObj.body) {
                            detailsObj.body = JSON.parse(detailsObj.body);
                        }
                        code = JSON.stringify(detailsObj, null, 4);
                    } catch (err) {
                        // Nothing to do
                    }
                }
                return code;
            },
            async fetchList() {
                // Pager params
                let params = { page: this.activePage };
                params.pageSize = this.itemsPerPage;
                // Filter params
                Object.keys(this.filter).forEach(key => {
                    if(this.filter[key]) {
                        params[key] = this.filter[key];
                    }
                });
                const response = await this.axios.get('/change-log', { params });
                this.list = response.data.results;
                this.total = Math.round(response.data.total / this.itemsPerPage);
            },
            async fetchOptions() {
                // Administrators
                const options = [{ value: '', label: 'Все' }];
                const administrators = [];
                (await this.axios.get('/administrators')).data.forEach(admin => {
                    options.push({ value: admin.id, label: admin.name });
                    administrators[admin.id] = admin.name;
                });
                this.filterOptions.administrators = options;
                this.administrators = administrators;
                // Object types
                const objectTypes = [{ value: '', label: 'Все' }];
                Object.values(OBJECT_TYPE).forEach(e => {
                    objectTypes.push({ value: e, label: e });
                });
                this.filterOptions.objectTypes = objectTypes;
                // Operation types
                const operationTypes = [{ value: '', label: 'Все' }];
                Object.values(OPERATION_TYPE).forEach(e => {
                    operationTypes.push({ value: e, label: e });
                });
                this.filterOptions.operationTypes = operationTypes;
            },
            async clearFilter() {
                this.filter = {
                    administrator_id: '',
                    object_type: '',
                    operation_type: '',
                    object_id: '',
                };
                this.activePage = 1;
                await this.fetchList();
            },
            getAdministrator(administrator_id) {
                if(this.administrators[administrator_id]) {
                    return this.administrators[administrator_id]
                }
                return administrator_id;
            },
        },
    };
</script>